import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Input} from 'reactstrap';

const DOMAIN_REGEXP_HTTP = /^(?:https?:)?(?:[\\/]{2})?(?:www\.)?([^\\/?]+)/;

class DomainInput extends Component {
    render() {
        return (
            <Input type='text' id={this.props.id || ''}
                   className={this.props.className || 'domain-input'}
                   value={this.props.value || ''}
                   onChange={this.handleChange}
                   onBlur={this.handleBlur}
                   onKeyDown={this.handleKeyDown}
                   placeholder={this.props.placeholder}
                   disabled={this.props.disabled}
                   required={this.props.required}
            />
        );
    }

    handleChange = (e) => {
        this.props.onChange(e.target.value);
    };

    handleBlur = (e) => {
        let data = e.target.value;
        let domainMatch = data.match(DOMAIN_REGEXP_HTTP);
        if (domainMatch && domainMatch.length > 1) {
            data = domainMatch[1]
        }
        if (this.props.onBlur) {
            this.props.onBlur(data);
        } else {
            this.props.onChange(data);
        }
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleBlur(e);
        }
    }
}

DomainInput.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
};

export default DomainInput;



// WEBPACK FOOTER //
// ./src/components/commonComponents/domainInput/DomainInput.js